import styled from '@emotion/styled';

import IconButton from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';

export const WhiteButton = styled(IconButton)`
  color: #ffffff;
`;

export const WhiteAvatar = styled(Avatar)`
  background-color: #ffffff;
  color: #3a84aa;
`;

export const PrimaryAvatar = styled(Avatar)`
  color: #ffffff;
  background-color: #3a84aa;
`;
